module.exports = __webpack_public_path__ + "static/media/BANNER-PACKING.2674ae9c.png";